const lineHeights = {
  "heading-4xl": 1,
  "heading-3xl": 1,
  "heading-2xl": 1,
  "heading-xl": 1.2,
  "heading-lg": 1.2,
  "heading-md": 1.4,
  "heading-sm": 1.4,
  "heading-xs": 1.4,
  "heading-2xs": 1.4,
  "body-xl": 1.4,
  "body-lg": 1.4,
  "body-md": 1.4,
  "body-sm": 1.2,
  "body-xs": 1.2
};
const fontSizes = {
  "heading-4xl": "4.5rem",
  "heading-3xl": "3.75rem",
  "heading-2xl": "3rem",
  "heading-xl": "2.25rem",
  "heading-lg": "1.875rem",
  "heading-md": "1.25rem",
  "heading-sm": "1rem",
  "heading-xs": "0.875rem",
  "heading-2xs": "0.75rem",
  "body-xl": "1.125rem",
  "body-lg": "1rem",
  "body-md": "0.875rem",
  "body-sm": "0.75rem",
  "body-xs": "0.625rem"
};
const fontWeights = {
  regular: "400",
  medium: "500",
  bold: "700"
};
const letterSpacings = {
  "heading-4xl": "-0.225rem",
  "heading-3xl": "-0.1875rem",
  "heading-2xl": "-0.15rem",
  "heading-xl": "-0.09rem",
  "heading-lg": "-0.075rem",
  "heading-md": "-0.05rem",
  "heading-sm": "-0.03rem",
  "heading-xs": "-0.02625rem",
  "heading-2xs": "-0.0225rem",
  "body-xl": "-0.03375rem",
  "body-lg": "-0.03rem",
  "body-md": "-0.02625rem",
  "body-sm": "-0.015rem",
  "body-xs": "-0.0125rem"
};
const fonts = {
  heading: "'ABCRepro-Medium', sans-serif",
  body: "'ABCRepro-Regular', sans-serif"
};

export { fontSizes, fontWeights, fonts, letterSpacings, lineHeights };
